import { Heading, Flex } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { PricingOption } from './PricingOption';
import { entityBoxStyle, entityNameHeadingProps } from './shared';

type PricingOptionsProps = {
  pricingOptions: NonNullable<
    CreditAgreement.DomainEntity.CreditAgreementFullArtifact['loanMechanicsV1']
  >['pricingOptions'];
};

export const PricingOptions = ({ pricingOptions }: PricingOptionsProps) => {
  return (
    <>
      {pricingOptions.map((pricingOption) => (
        <Flex style={entityBoxStyle} key={pricingOption.key}>
          <Heading {...entityNameHeadingProps}>{pricingOption.name}</Heading>
          <PricingOption pricingOption={pricingOption} />
        </Flex>
      ))}
    </>
  );
};
